module.exports = __webpack_public_path__ + "static/ETCH_CRAB-f8d90b15c649c93453040a8cfe1c4eee.gif";